export const linkFocusStyles =
  'focus:ring-offset-2 focus:ring-2 focus:ring-accent-500 focus:outline-none';

export const linkFocusWithinStyles =
  'focus-within:ring-offset-2 focus-within:ring-2 focus-within:ring-accent-500 focus-within:outline-none';

export const linkGroupFocusStyles =
  'group-focus:ring-offset-2 group-focus:ring-2 group-focus:ring-accent-500 group-focus:outline-none';
